<template>
  <div
  id="direct-debit-inbox"
  class="page page-on-center close-picker"
  data-page="inbox-page" @ptr:refresh="onRefresh(false)">

  <div class="showSmallScreenOnly" v-bind:class="colorBottomButton">
    <f7-fab class="leftfav button-fab bottomButton floatingButtonToolbarBlank" @click="extractCSV(inboxMessages)">
      <f7-icon f7="document_text"></f7-icon>
    </f7-fab>
  </div>

  <div class="page-content infinite-scroll"
  style="z-index:9"
  @infinite="onInfinite">

    <div class="pull-to-refresh-layer">
      <div class="preloader"></div>
      <div class="pull-to-refresh-arrow"></div>
    </div>

    <page-nav-bar
      :currentServiceName="serviceName"
      popoverName=".popoverInbox"
      :subNavTitle="$t('common.received_reqsts')"
      :menuAccess="true"
      :paymentsNumber="directDebitNumber">
    </page-nav-bar>

    <div class="row rowBackgroundImage showLargeScreenOnly" v-bind:class="colorBottomButton">
      <button class="milkyBlock boxRequest pull-right" @click="extractCSV(inboxMessages)">
        <f7-icon f7="document_text"></f7-icon>
        <span class="fab-label">{{ $t('common.extract_csv') }}</span>
      </button>
    </div>

    <div class="searchForm">
  		<!-- <cm-messages-filter
        class="researchfilter"
        style="position:relative;z-index:10"
        :isPayments="true"
        :received="true">
      </cm-messages-filter> -->

      <transactions-list
        :filterBy="filterBy"
        v-bind:inMessages="inboxMessages">
      </transactions-list>

      <cm-pagination
        :firstIndex="paginationObject.firstIndex"
        :maxResultsByPage="paginationObject.maxResults"
        :nbResultsTotal="paginationObject.nbResultsTotal"
        :refreshEvent="paginationObject.refresh">
      </cm-pagination>
      <div class="toolbarPageBottomBlank"></div>
    </div>
  </div>
</div>
</template>

<script>
import {errorMessageAlert} from '@/helpers/alert'
import TransactionsList from '@/pages/requests/TransactionsList.vue'
import MessagesFilter from '@/components/common/Filter.vue'
import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import pagination from '@/components/common/pagination.vue'
import moment from 'moment'
import {statusLabel} from '@/helpers/labels'
// import {loadPage} from '@/helpers/routing'

export default {
  name: 'Inbox',
  components: {
    'page-nav-bar': pageNavBar,
    'transactions-list': TransactionsList,
    'cm-messages-filter': MessagesFilter,
    'cm-pagination': pagination,
    'bottom-toolbar': bottomToolbar
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      serviceName: 'Direct Debit',
      inboxMessages: [],
      inboxDir: 0,
      pageCounter: 0,
      noMoreMessages: false,
      newRequest: 1,
      scrollDown: false,
      filterBy: '',
      afterBack: false,
      directDebitNumber: '',
      noMore: false,
      scrollFlag: false,
      paginationObject: {}
    }
  },
  created () {
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 10
    this.paginationObject['nbResultsTotal'] = 0
    this.paginationObject['refresh'] = 'direct-debit-filtered'
    let that = this
    this.$f7.params.swipePanel = that.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    this.$f7.params.panelsCloseByOutside = that.$engine.services.directPayments.filter.smartphoneStorage
    this.$bus.$off('direct-debit-filtered')
    this.$bus.$on('direct-debit-filtered', index => {
      that.onRefresh(false, index)
      that.pageCounter = 0
    })
    this.onRefresh(true)
  },
  beforeDestroy () {
    let that = this
    this.$f7.onPageAfterBack('details-page', function (page) {}).remove()
    that.$engine.services.directDebit.filter.cleanFilterCondition()
  },
  methods: {
    detachInfinit () {
      this.$$('.infinite-scroll-preloader').remove()
      this.$f7.detachInfiniteScroll(this.$$('.infinite-scroll'))
      this.$engine.settings.set({sendboxPreloaderRemoved: true})
      if (!this.emptyBox) this.noMore = true
    },
    attachInfinit () {
      if (this.$settings.sendboxPreloaderRemoved) {
        this.$$('.infinite-scroll').append(
        '<div class="infinite-scroll-preloader"><div class="preloader"></div></div>'
        )
        this.$f7.attachInfiniteScroll(this.$$('.infinite-scroll'))
        this.$engine.settings.set({sendboxPreloaderRemoved: false})
      }
      this.noMore = false
    },
    onInfinite: function (event) {
      if (this.scrollFlag) {
        this.scrollFlag = false
        let that = this
        that.pageCounter = that.pageCounter + 1
        that.$engine.services.directDebit.update(0, this.paginationObject.maxResults, this.paginationObject.firstIndex, that.$engine.services.directDebit.filter.getConditionObject())
        .then(resp => {
          this.paginationObject.nbResultsTotal = resp.data.totalDirectDebits
          this.directDebitNumber = resp.data.totalDirectDebits
          let directDebits = resp.data.directDebits
          if (directDebits.length > 0) {
            for (let i = 0; i < directDebits.length; i++) {
              that.inboxMessages.push(directDebits[i])
            }
            if (directDebits.length < 10) {
              that.detachInfinit()
            }
          } else {
            that.detachInfinit()
          }
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
      }
    },
    onRefresh: function (noAttach, index = 1) {
      const that = this
      this.pageCounter = 0
      this.scrollFlag = false
      this.paginationObject.firstIndex = index
      that.$engine.services.directDebit.update(0, this.paginationObject.maxResults, this.paginationObject.firstIndex, that.$engine.services.directDebit.filter.getConditionObject())
      .then(resp => {
        this.paginationObject.nbResultsTotal = resp.data.totalDirectDebits
        this.directDebitNumber = resp.data.totalDirectDebits
        this.updateInbox(resp.data.directDebits, noAttach)
        that.$f7.pullToRefreshDone()
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    updateInbox (directDebits, noAttach = false) {
      this.inboxMessages = directDebits
      if (directDebits.length === 10) {
        if (!noAttach) {
          this.attachInfinit()
        }
      } else {
        this.detachInfinit()
      }
    },
    onSearch (query, found) {
      this.filterBy = query
    },
    onClear: function (event) {
      this.filterBy = ''
      this.attachInfinit()
    },
    onEnable: function (event) {
      this.detachInfinit()
    },
    onDisable: function (event) {
      this.attachInfinit()
    },
    OpenFormsPage () {
      const that = this
      that.$f7.popup('.forms-page')
    },
    extractCSV (inboxMessages) {
      let firstLine = this.$t('common.status.status_label') + ';' +
        this.$t('common.rsn') + ';' + this.$t('common.amnt') + ';' + this.$t('common.crdtr_name') + ';' +
        this.$t('common.date_label') + '\r\n'

      let lines = ''
      for (let datas in inboxMessages) {
        lines += statusLabel(this.$i18n, inboxMessages[datas]['status'], inboxMessages[datas]['negotStatus'], 0) + ';' +
        inboxMessages[datas]['reason'] + ';' +
        inboxMessages[datas]['amount'] + ';' +
        inboxMessages[datas]['creditorName'] + ';' +
        inboxMessages[datas]['creationDate'] + '\r\n'
      }

      let data = firstLine + lines

      const linkSource = 'data:text/csv;charset:utf-8,' + data
      const downloadLink = document.createElement('a')
      let today = moment()
      const fileName = 'receivedModularLoan' + today.unix() + '.csv'

      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
    }
  }
}
</script>

<style>
.rowBackgroundImage {
  background-image: url('../../../assets/static/images/MenuFont.png');
  background-size: contain;
}
</style>



// WEBPACK FOOTER //
// InboxPage.vue?235706e9